import { Box, Typography } from '@mui/material';
import { purchaseSuccessCheckSrc } from '../../assets/bazzar';
import { BazaarBackLink, BazaarDialogShell, BazaarRibbonTitle } from './bazaarDialogShared';

/** Figma 8736:26513 / 8736:26518 — RapCoin purchase success popup */
const DIALOG_MIN_HEIGHT = 335;
const SUCCESS_ICON_SIZE = 77;
const MESSAGE_MAX_WIDTH = 306;

const messageTextSx = {
  color: '#fff',
  fontWeight: 600,
  fontSize: 16,
  lineHeight: '24px',
  letterSpacing: '0.8px',
  textAlign: 'center',
};

function getSuccessLines(card) {
  if (!card) {
    return {
      line1: '501 RapCoins Added in your',
      line2: 'coin wallet',
    };
  }

  if (card.variant === 'store') {
    if (card.tone === 'coin') {
      return {
        line1: `${card.title} RapCoins Added in your`,
        line2: 'coin wallet',
      };
    }

    if (card.gemType === 'mix') {
      return {
        line1: `${card.title} Boosts & ${card.secondaryTitle} Swaps Added`,
        line2: 'in your RapGems wallet',
      };
    }

    if (card.tone?.includes('gem')) {
      return {
        line1: `${card.title} RapGems Added in your`,
        line2: 'RapGems wallet',
      };
    }

    if (card.tone === 'vip') {
      return {
        line1: `${card.subtitle} Added in your`,
        line2: 'VIP Rooms wallet',
      };
    }
  }

  if (card.variant === 'passes') {
    return {
      line1: card.title,
      line2: 'Activated Successfully',
    };
  }

  return {
    line1: 'Purchase Successful!',
    line2: '',
  };
}

/** Figma 8736:26528 — success message (two lines) */
function PurchaseSuccessMessage({ line1, line2 }) {
  return (
    <Box
      sx={{
        mt: 2.2,
        maxWidth: MESSAGE_MAX_WIDTH,
        mx: 'auto',
        textAlign: 'center',
      }}
    >
      <Typography sx={{ ...messageTextSx, mb: line2 ? 0 : undefined }}>{line1}</Typography>
      {line2 ? <Typography sx={messageTextSx}>{line2}</Typography> : null}
    </Box>
  );
}

export default function PurchaseSuccessDialog({ open, card, onClose }) {
  const { line1, line2 } = getSuccessLines(card);

  return (
    <BazaarDialogShell open={open} onClose={onClose} minHeight={DIALOG_MIN_HEIGHT}>
      {/* Figma 8736:26535 + 8736:26539 + 8736:26540 */}
      <BazaarRibbonTitle>Purchased Successful!</BazaarRibbonTitle>

      {/* Figma 8736:26529 — success_check_ic */}
      <Box
        component="img"
        src={purchaseSuccessCheckSrc}
        alt="Purchase successful"
        sx={{
          width: SUCCESS_ICON_SIZE,
          height: SUCCESS_ICON_SIZE,
          display: 'block',
          mx: 'auto',
          mt: 2.5,
          objectFit: 'contain',
        }}
      />

      <PurchaseSuccessMessage line1={line1} line2={line2} />

      {/* Figma 8736:26522 + 8736:26533 — back link */}
      <BazaarBackLink onClick={onClose} />
    </BazaarDialogShell>
  );
}
